import { Component, DOCUMENT, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-404',
  imports: [MainLayout, MarginWrapper],
  template: `
    <allas-main-layout>
      <allas-margin-wrapper>
        <main
          class="min-h-[calc(100vh-300px)] flex flex-col xl:flex-row justify-center items-center gap-12"
        >
          <img
            src="images/misc/404.webp"
            alt="Bajo Construcción"
            class="w-1/2 h-1/2 object-contain order-2 xl:order-1"
          />
          <div class="flex flex-col gap-2 order-1 xl:order-2">
            <h1 class="text-4xl xl:text-6xl font-bold fs-condensed">
              Página no encontrada
            </h1>
            <p class="text-sm xl:text-lg fs-condensed">
              La página que buscas no existe. Por favor, regresa a la página de
              inicio.
            </p>
          </div>
        </main>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class _404 {
  private titleService = inject(Title);
  private metaService = inject(Meta);
  private document = inject(DOCUMENT);

  constructor() {
    this.document.head.insertAdjacentHTML(
      'beforeend',
      `
      <meta name="x-not-found" content="true">
    `
    );
    this.titleService.setTitle('Página no encontrada - Allas Repuestos');
    this.metaService.updateTag({
      name: 'description',
      content:
        'La página que buscas no existe. Por favor, regresa a la página de inicio de Allas Repuestos.',
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Página no encontrada - Allas Repuestos',
    });

    this.metaService.updateTag({
      property: 'og:description',
      content:
        'La página que buscas no existe. Por favor, regresa a la página de inicio de Allas Repuestos.',
    });

    this.metaService.updateTag({
      property: 'og:type',
      content: 'website',
    });

    this.metaService.updateTag({
      property: 'og:image',
      content: 'https://www.allasrepuestos.com/logos/isotipo.webp',
    });

    this.metaService.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    this.metaService.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });

    this.metaService.updateTag({
      name: 'twitter:title',
      content: 'Página no encontrada - Allas Repuestos',
    });
  }
}
